module.exports = __webpack_public_path__ + "static/media/teacher.fc8df4a9.jpg";